var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"color":"#979090","bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({attrs:{"color":"black","dark":""}},'v-icon',attrs,false),on),[_vm._v("\n      mdi-information-outline\n    ")])]}}])},[_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }